import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { PageCard } from 'src/modules/contentList/components/pageCard';
import { DraggingPageContext } from 'src/modules/contentList/contexts/draggingPageContext';
import { ContentLoader } from 'src/shared/components/contentLoader';
import { LoadError } from 'src/shared/components/loadError';
const MAX_LOADERS = 10;
export function PageList({ status, onTryAgain, data, totalPages }) {
    const { draggingPageId } = useContext(DraggingPageContext);
    const pagesCount = Math.min(totalPages ?? 1, MAX_LOADERS);
    if (status === 'pending') {
        return (_jsx(ContentLoader, { count: pagesCount, className: "h-[7rem] w-full rounded-large md:h-[5.375rem]" }));
    }
    if (status === 'error') {
        return _jsx(LoadError, { onTryAgain: onTryAgain });
    }
    return data?.map((page) => (_jsx(PageCard, { page: page, isDragging: draggingPageId === page.id }, page.id)));
}
